var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRichConactD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6082_16528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 3.8002C7.47146 3.8002 3.8002 7.47146 3.8002 12.0002C3.8002 13.5951 4.25472 15.0814 5.04095 16.3394C5.15339 16.5193 5.18976 16.7365 5.14205 16.9433L4.56753 19.4329L7.05712 18.8583C7.26385 18.8106 7.48107 18.847 7.66099 18.9594C8.91903 19.7457 10.4053 20.2002 12.0002 20.2002C16.5289 20.2002 20.2002 16.5289 20.2002 12.0002C20.2002 7.47146 16.5289 3.8002 12.0002 3.8002ZM2.2002 12.0002C2.2002 6.5878 6.5878 2.2002 12.0002 2.2002C17.4126 2.2002 21.8002 6.5878 21.8002 12.0002C21.8002 17.4126 17.4126 21.8002 12.0002 21.8002C10.2173 21.8002 8.5436 21.3234 7.10202 20.49L3.68008 21.2797C3.41131 21.3417 3.12955 21.2609 2.93451 21.0659C2.73947 20.8708 2.65866 20.5891 2.72068 20.3203L3.51036 16.8984C2.67701 15.4568 2.2002 13.7831 2.2002 12.0002ZM8.2002 10.0002C8.2002 9.55837 8.55837 9.2002 9.0002 9.2002H12.0002C12.442 9.2002 12.8002 9.55837 12.8002 10.0002C12.8002 10.442 12.442 10.8002 12.0002 10.8002H9.0002C8.55837 10.8002 8.2002 10.442 8.2002 10.0002ZM9.0002 13.2002C8.55837 13.2002 8.2002 13.5584 8.2002 14.0002C8.2002 14.442 8.55837 14.8002 9.0002 14.8002H15.0002C15.442 14.8002 15.8002 14.442 15.8002 14.0002C15.8002 13.5584 15.442 13.2002 15.0002 13.2002H9.0002Z",
    fill: "#c0d2f0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6082_16528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichConactD);
export default __webpack_public_path__ + "static/media/rich-conact_d.26e4dc752a74e4534b35b1f6daab5e78.svg";
export { ForwardRef as ReactComponent };